import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileCode } from 'lucide-react';
import type { YaraRule } from '@/lib/types/api';

interface YaraRulesListProps {
  yaraRules: YaraRule[];
}

export function YaraRulesList({ yaraRules }: YaraRulesListProps) {
  if (!yaraRules?.length) return null;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Yara Rules</CardTitle>
        <span className="text-sm text-muted-foreground">
          {yaraRules.length} rule{yaraRules.length !== 1 ? 's' : ''}
        </span>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {yaraRules.map((rule, index) => (
            <Card key={index} className="hover:shadow-md transition-shadow">
              <CardContent className="p-4 space-y-4">
                <div className="flex items-center gap-2">
                  <FileCode className="h-5 w-5 text-primary" />
                  <span className="font-mono text-sm truncate flex-1" title={rule.yara_name}>
                    {rule.yara_name}
                  </span>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  className="w-full"
                  onClick={() => window.open(rule.yara_url, '_blank')}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download Rule
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}